/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/core';

export interface RequiredFieldNoticeProps {}

export const RequiredFieldNotice: React.FC<RequiredFieldNoticeProps> = () => {
  return (
    <p
      css={css`
        display: block;
        font-size: smaller;
        text-align: center;
        width: 100%;
        margin: 0;
      `}
    >
      All fields are required
    </p>
  );
};
